import * as React from 'react';
import { useStore } from 'zustand';
import { CriteriaStoreContext } from '../context';

export const useCriteriaStoreMovePredicateToRoot = () => {
    const { store } = React.useContext(CriteriaStoreContext);
    if (!store) throw new Error('Missing CriteriaStoreContext.Provider in the tree');
    const movePredicateToRoot = useStore(store, (s) => s.movePredicateToRoot);

    return movePredicateToRoot;
};
